import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "edit-connector",
  class: "d-flex flex-fill edit-page-40"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "edit-header" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "card-body overflow-auto" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = {
  id: "spec",
  class: "display"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_9 = {
  key: 0,
  class: "margin-top-10"
}
const _hoisted_10 = { class: "d-flex flex-row align-items-center" }
const _hoisted_11 = { class: "p-text" }
const _hoisted_12 = { class: "d-flex flex-row align-items-center margin-top-10" }
const _hoisted_13 = { class: "p-text" }
const _hoisted_14 = {
  key: 0,
  class: "d-flex flex-row align-items-center margin-top-10"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "p-text" }, "Supported Authentication Types:", -1)
const _hoisted_16 = { class: "d-flex flex-row align-items-center margin-top-10" }
const _hoisted_17 = { class: "p-text" }
const _hoisted_18 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-2 mb-3" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_21 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_23 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_25 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_27 = { class: "card-footer footer" }
const _hoisted_28 = { class: "float-right" }
const _hoisted_29 = { class: "loader-div-40" }
const _hoisted_30 = ["src"]

import { computed, onBeforeMount, ref, watch } from "vue";
import { ElButton, ElInput, ElOption, ElSelect, ElTag } from "element-plus";
import { TYPE } from "vue-toastification";
import {
  addConnector,
  editConnector,
  getConnector,
  getConnectorSpecs,
} from "@/connector/services/connector.service";
import { showAlert } from "@/core/popup";
import { currentRoute, router } from "@/core/router";
import { hasPermission } from "@/core/auth";
import i18n from "@/core/i18n/i18n";
import { DEFAULT_LOGO, ASSETS_BASE_URL } from "@/core/logo";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditConnector',
  setup(__props) {

const { t } = i18n.global;
const pageName = computed(() =>
  currentRoute.value.name === "createConnectors"
    ? t("Common.Create")
    : t("Common.Edit")
);

const specs = ref([]);
const selectedSpec = ref();
const connector = ref(defaultConnector());
const id = ref();

const pageLoading = ref(false);

const responseLoading = ref(false);

const isValid = computed(
  () =>
    connector.value.name &&
    connector.value.connectorSpecId &&
    connector.value.description &&
    connector.value.connectorType &&
    connector.value.pricingType
);

async function saveConnector() {
  responseLoading.value = true;
  if (isValid.value && hasPermission("CONNECTORS.CONNECTOR.SAVE")) {
    if (id.value) {
      await editConnector(connector.value).then((response) => {
        if (response) {
          showAlert(TYPE.SUCCESS, t("Connector.ConnectorUpdated"));
        }
      });
    } else {
      await addConnector(connector.value).then((response) => {
        if (response) {
          showAlert(TYPE.SUCCESS, t("Connector.ConnectorCreated"));
        }
      });
    }
    await router.push("/connectors");
  } else if (hasPermission("CONNECTORS.CONNECTOR.SAVE")) {
    showAlert(TYPE.WARNING, t("Common.WarningMsg"));
  }
  responseLoading.value = false;
}

function defaultConnector() {
  return {
    active: true,
    camelComponentName: undefined,
    connectorSpecId: undefined,
    createdAt: undefined,
    createdBy: {
      id: undefined,
    },
    connectorType: undefined,
    description: undefined,
    id: undefined,
    modifiedBy: {
      id: undefined,
    },
    name: undefined,
    organisation: {
      id: undefined,
      createdBy: {
        id: undefined,
      },
      modifiedBy: {
        id: undefined,
      },
    },
    pricingType: undefined,
    updatedAt: undefined,
  };
}

watch(
  () => connector.value.connectorSpecId,
  () => {
    if (connector.value.connectorSpecId) {
      const filteredSpec = specs.value.filter(
        (spec) => spec.spec.id === connector.value.connectorSpecId
      );
      // eslint-disable-next-line prefer-destructuring
      selectedSpec.value = filteredSpec[0].spec;
      connector.value.camelComponentName = selectedSpec.value.componentName;
    } else {
      selectedSpec.value = undefined;
    }
  }
);

onBeforeMount(async () => {
  pageLoading.value = true;
  specs.value = await getConnectorSpecs();

  id.value = currentRoute.value.params.id as string;
  if (id.value) {
    await getConnector(id.value).then((response) => {
      if (response) {
        connector.value = response;
      }
    });
  }
  pageLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(pageName.value) + " " + _toDisplayString(_unref(t)("Common.Connector")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_unref(t)("Connector.Spec")), 1),
              _hoisted_8
            ]),
            _createVNode(_unref(ElSelect), {
              modelValue: connector.value.connectorSpecId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((connector.value.connectorSpecId) = $event)),
              id: "connector-select-spec",
              filterable: "",
              placeholder: _unref(t)('Connector.SelectSpec')
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(specs.value, (spec, index) => {
                  return (_openBlock(), _createBlock(_unref(ElOption), {
                    id: 'connector-spec-option-' + index,
                    label: spec.spec.id,
                    value: spec.spec.id,
                    key: spec.spec.id
                  }, null, 8, ["id", "label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          (selectedSpec.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, [
                    _createTextVNode(_toDisplayString(_unref(t)("Connector.ComponentName")) + ": ", 1),
                    _createElementVNode("strong", null, _toDisplayString(selectedSpec.value.componentName), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)("Connector.ReqAuth")) + ":", 1),
                  _createTextVNode("     "),
                  (selectedSpec.value.requiresAuthentication)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        style: {"color":"lightgreen"},
                        icon: "check"
                      }))
                    : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        class: "color-red",
                        icon: "times"
                      }))
                ]),
                (selectedSpec.value.requiresAuthentication)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _createTextVNode("     "),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedSpec.value.supportedAuthTypes, (item) => {
                        return (_openBlock(), _createBlock(_unref(ElTag), {
                          key: item,
                          class: "margin-left-3",
                          size: "mini"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(t)("Connector.HasConsumer")) + ":", 1),
                  _createTextVNode("     "),
                  (selectedSpec.value.hasConsumer)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        style: {"color":"lightgreen"},
                        icon: "check"
                      }))
                    : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        class: "color-red",
                        icon: "times"
                      }))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_unref(t)("Common.Name")), 1),
              _hoisted_20
            ]),
            _createVNode(_unref(ElInput), {
              id: "connector-name",
              modelValue: connector.value.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((connector.value.name) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_unref(t)("Common.Description")), 1),
              _hoisted_22
            ]),
            _createVNode(_unref(ElInput), {
              id: "connector-description",
              modelValue: connector.value.description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((connector.value.description) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_unref(t)("Connector.ConnectorType")), 1),
              _hoisted_24
            ]),
            _createVNode(_unref(ElSelect), {
              modelValue: connector.value.connectorType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((connector.value.connectorType) = $event)),
              id: "connector-type",
              placeholder: _unref(t)('Common.SelectConnectorType')
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElOption), {
                  label: 'CORE',
                  id: "connector-type-option-core",
                  value: 'CORE'
                }),
                _createVNode(_unref(ElOption), {
                  label: 'EXTERNAL',
                  id: "connector-type-option-external",
                  value: 'EXTERNAL'
                })
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_unref(t)("Connector.PricingType")), 1),
              _hoisted_26
            ]),
            _createVNode(_unref(ElSelect), {
              modelValue: connector.value.pricingType,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((connector.value.pricingType) = $event)),
              id: "connector-pricing-type",
              placeholder: _unref(t)('Connector.SelectPricingType')
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElOption), {
                  label: 'FREE',
                  id: "connector-pricing-option-free",
                  value: 'FREE'
                }),
                _createVNode(_unref(ElOption), {
                  label: 'PAID',
                  id: "connector-pricing-option-paid",
                  value: 'PAID'
                })
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_unref(ElButton), {
            class: "btn-oneTeg3",
            id: "connector-back",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push('/connectors')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Common.Back")), 1)
            ]),
            _: 1
          }),
          (_unref(hasPermission)('CONNECTORS.CONNECTOR.SAVE'))
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 0,
                class: "btn-oneTeg2",
                id: "connector-submit",
                onClick: saveConnector
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("Common.Save")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, !pageLoading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_29, [
      _createElementVNode("img", {
        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
        alt: "Loading...",
        class: "loader-logo-40"
      }, null, 8, _hoisted_30)
    ], 512), [
      [_vShow, responseLoading.value || pageLoading.value]
    ])
  ]))
}
}

})